// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EstateWaterfallInsurancePolicy_InsurancePolicyFragment } from './EstateWaterfallInsurancePolicy.generated';
import { GraphViz_NodeConfigFragment } from '../../graphViz/graphql/GraphVizNodeConfig.fragment.generated';
import { EstateWaterfallTransferLogItem_EstateWaterfallTransferFragment } from './EstateWaterfallTransferLogItem.generated';
import { DispositiveProvisions_DispositiveProvisionFragment } from '../../dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';
import { HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment } from '../../../utils/hypotheticalTransfers/graphql/HypotheticalTransferUtils.generated';
import { GetWaterfallSummary_EstateWaterfallEventFragment, GetWaterfallSummary_GrowthProfileFragment } from './GetWaterfallSummary.generated';
import { TaxDetail_FederalTaxDetailFragment, TaxDetail_StateTaxDetailFragment, TaxDetail_StateInheritanceTaxDetailFragment, TaxDetail_GstTaxDetailFragment, TaxDetail_GiftTaxDetailFragment, TaxDetail_StateGiftTaxDetailFragment } from '../../taxes/graphql/TaxDetail.generated';
import { gql } from '@apollo/client';
import { EstateWaterfallInsurancePolicy_InsurancePolicyFragmentDoc } from './EstateWaterfallInsurancePolicy.generated';
import { GraphViz_NodeConfigFragmentDoc } from '../../graphViz/graphql/GraphVizNodeConfig.fragment.generated';
import { EstateWaterfallTransferLogItem_EstateWaterfallTransferFragmentDoc } from './EstateWaterfallTransferLogItem.generated';
import { DispositiveProvisions_DispositiveProvisionFragmentDoc } from '../../dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';
import { HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../utils/hypotheticalTransfers/graphql/HypotheticalTransferUtils.generated';
import { GetWaterfallSummary_EstateWaterfallEventFragmentDoc, GetWaterfallSummary_GrowthProfileFragmentDoc } from './GetWaterfallSummary.generated';
import { TaxDetail_FederalTaxDetailFragmentDoc, TaxDetail_StateTaxDetailFragmentDoc, TaxDetail_StateInheritanceTaxDetailFragmentDoc, TaxDetail_GstTaxDetailFragmentDoc, TaxDetail_GiftTaxDetailFragmentDoc, TaxDetail_StateGiftTaxDetailFragmentDoc } from '../../taxes/graphql/TaxDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateWaterfall_MinimalNodeFragment = { __typename?: 'EstateWaterfallVizNode', id: string, _cacheKey: string, isHidden: boolean, afterDeath: Types.AfterDeath, value: CurrencyUSD, waterfallID: string, isHypothetical: boolean, group?: { __typename?: 'GraphVisualizationGroup', id: string, namespace?: string | null } | null };

export type EstateWaterfall_InsurancePolicyFragment = (
  { __typename?: 'InsurancePolicy' }
  & EstateWaterfallInsurancePolicy_InsurancePolicyFragment
);

export type EstateWaterfall_ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, cltProposal?: { __typename?: 'CLTProposal', id: string } | null, crtProposal?: { __typename?: 'CRTProposal', id: string } | null, household: { __typename?: 'Household', id: string } };

export type EstateWaterfall_NodeFragment = (
  { __typename?: 'EstateWaterfallVizNode', transferredToEstateTax?: CurrencyUSD | null, transferredToGiftingTax?: CurrencyUSD | null, waterfallID: string, valueBeforeDispositions?: CurrencyUSD | null, valueBeforePouroverWills?: CurrencyUSD | null, inEstateStatus: Types.EntityInEstateStatus, addedDeathBenefit?: CurrencyUSD | null, futureDeathBenefit?: CurrencyUSD | null, taxableValue?: CurrencyUSD | null, nonTaxableValue?: CurrencyUSD | null, valueHistory: Array<{ __typename?: 'EstateWaterfallNodeValueHistory', year: number, beginningOfYearValue?: CurrencyUSD | null }>, nodeConfiguration?: (
    { __typename?: 'EntityGraphNodeConfiguration' }
    & GraphViz_NodeConfigFragment
  ) | null, node: { __typename?: 'AISuggestion', id: string } | { __typename?: 'AISuggestionEvidence', id: string } | { __typename?: 'AccessAgeParameter', id: string } | { __typename?: 'AccessParameter', id: string } | { __typename?: 'Account', id: string } | { __typename?: 'ActiveEstateInsightsPage', id: string } | { __typename?: 'Activity', id: string } | { __typename?: 'Address', id: string } | { __typename?: 'Answer', id: string } | { __typename?: 'AnswerEvidence', id: string } | { __typename?: 'AnswerRevision', id: string } | { __typename?: 'Approval', id: string } | { __typename?: 'AssetClass', id: string } | { __typename?: 'AssetGroup', id: string } | { __typename?: 'AssetStatic', id: string } | { __typename?: 'AssetV2', id: string } | { __typename?: 'AssetValuationV2', id: string } | { __typename?: 'AssetValueV2', id: string } | { __typename?: 'AsyncJob', id: string } | { __typename?: 'BalanceSheetBundleConfiguration', id: string } | { __typename?: 'BalanceSheetCategory', id: string } | { __typename?: 'BalanceSheetViewConfiguration', id: string } | { __typename?: 'BeneficiariesBundleConfiguration', id: string } | { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string } | { __typename?: 'Beneficiary', id: string } | { __typename?: 'BeneficiaryAccessParameter', id: string } | { __typename?: 'BeneficiaryDesignationGroup', id: string } | { __typename?: 'BeneficiaryDistribution', id: string } | { __typename?: 'BeneficiaryDistributionParameter', id: string } | { __typename?: 'BeneficiaryPage', id: string } | { __typename?: 'BeneficiaryPowerOfAppointment', id: string } | { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTProposal', id: string } | { __typename?: 'CLTTrust', id: string } | { __typename?: 'CRTProposal', id: string } | { __typename?: 'CRTTrust', id: string } | { __typename?: 'Capability', id: string } | { __typename?: 'Cashflow', id: string } | { __typename?: 'ClientOrganization', name: string, id: string, clientOrganizationKind?: Types.ClientOrganizationKind | null } | { __typename?: 'ClientPresentationV2', id: string } | { __typename?: 'ClientProfile', displayName: string, lastName: string, id: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null } } | { __typename?: 'ClientProfileRelationship', id: string } | { __typename?: 'Collaborator', id: string } | { __typename?: 'ComparedWaterfall', id: string } | { __typename?: 'CompletedEstateInsightsPage', id: string } | { __typename?: 'ControllingParty', id: string } | { __typename?: 'Conversation', id: string } | { __typename?: 'CoverPageConfiguration', id: string } | { __typename?: 'CustodialPersonalAccount', id: string } | { __typename?: 'DSUEPortability', id: string } | { __typename?: 'DiagramArtifact', id: string } | { __typename?: 'DiagramArtifactPrompt', id: string } | { __typename?: 'DispositionScenario', id: string } | { __typename?: 'DispositiveProvision', id: string } | { __typename?: 'DispositiveProvisionTemplate', id: string } | { __typename?: 'DividerBundleConfiguration', id: string } | { __typename?: 'DividerTemplateBundleConfiguration', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'DocumentQuestion', id: string } | { __typename?: 'DocumentQuestionAnswers', id: string } | { __typename?: 'DocumentSummary', id: string } | { __typename?: 'DocumentSummaryPage', id: string } | { __typename?: 'DocumentSummaryPrompt', id: string } | { __typename?: 'DocumentSummaryPromptTestRun', id: string } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string } | { __typename?: 'DonorAdvisedFund', id: string } | { __typename?: 'Employee', id: string } | { __typename?: 'EntitiesOverviewBundleConfiguration', id: string } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string } | { __typename?: 'Entity', extendedDisplayKind: string, stage: Types.EntityStage, id: string, entityKind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'CLTTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'CRTTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'GRATTrust', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'ILITTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'PrivateFoundation', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'SLATTrust', id: string, displayName: string, policies?: Array<(
        { __typename?: 'InsurancePolicy' }
        & EstateWaterfall_InsurancePolicyFragment
      )> | null, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string }> | null } } | { __typename?: 'EntityDiagram', id: string } | { __typename?: 'EntityDocumentRelationship', id: string } | { __typename?: 'EntityGraphView', id: string } | { __typename?: 'EntityGraphViewBundleConfiguration', id: string } | { __typename?: 'EntityNotes', id: string } | { __typename?: 'EntityProposal', id: string } | { __typename?: 'EntitySummaryBundleConfiguration', id: string } | { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string } | { __typename?: 'EntityTask', id: string } | { __typename?: 'EntityTaxInfo', id: string } | { __typename?: 'EstateInsight', id: string } | { __typename?: 'EstateInsightReference', id: string } | { __typename?: 'EstateInsightsBundleConfiguration', id: string } | { __typename?: 'EstateTaxScenario', id: string } | { __typename?: 'EstateWaterfall', id: string } | { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string } | { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string } | { __typename?: 'EstateWaterfallMessageContext', id: string } | { __typename?: 'EstateWaterfallVisualizationConfig', id: string } | { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | { __typename?: 'FamilyTreeBundleConfiguration', id: string } | { __typename?: 'FamilyTreeConfiguration', id: string } | { __typename?: 'FeatureFlag', id: string } | { __typename?: 'FeatureFlagQueryRule', id: string } | { __typename?: 'File', id: string } | { __typename?: 'FilePage', id: string } | { __typename?: 'FileParagraph', id: string } | { __typename?: 'Form', id: string } | { __typename?: 'FormVersion', id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATAnnuityV2', id: string } | { __typename?: 'GRATProposalScenario', id: string } | { __typename?: 'GRATTrust', id: string } | { __typename?: 'GiftingProposal', id: string } | { __typename?: 'GiftingProposalCashFlow', id: string } | { __typename?: 'GiftingProposalGift', id: string } | { __typename?: 'GiftingProposalGiftSender', id: string } | { __typename?: 'GiftingProposalPortfolio', id: string } | { __typename?: 'GiftingProposalScenario', id: string } | { __typename?: 'GraphVisualizationGroup', id: string } | { __typename?: 'GrowthProfile', id: string } | { __typename?: 'GrowthProfileOverride', id: string } | { __typename?: 'Household', id: string } | { __typename?: 'HypotheticalCLT', id: string } | { __typename?: 'HypotheticalCRT', id: string } | { __typename?: 'HypotheticalGRAT', id: string } | { __typename?: 'HypotheticalInsurance', id: string } | { __typename?: 'HypotheticalSaleLoan', id: string } | { __typename?: 'HypotheticalTransferAsset', id: string } | { __typename?: 'HypotheticalTransferFundingSource', id: string } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string } | { __typename?: 'ILITCrummeyLetter', id: string } | { __typename?: 'ILITTrust', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'IncomeTaxPaymentConfig', id: string } | { __typename?: 'IndividualPersonalAccount', id: string } | { __typename?: 'InferredField', id: string } | { __typename?: 'InferredFieldEvidence', id: string } | { __typename?: 'InsightsTemplateBundleConfiguration', id: string } | { __typename?: 'InsurancePersonalAccount', id: string } | { __typename?: 'InsurancePolicy', id: string } | { __typename?: 'InsurancePremiumPayment', id: string } | { __typename?: 'IntegrationAssetClass', id: string } | { __typename?: 'IntegrationCashflow', id: string } | { __typename?: 'IntegrationClient', id: string } | { __typename?: 'IntegrationConfiguration', id: string } | { __typename?: 'IntegrationEntity', id: string } | { __typename?: 'IntegrationInsurance', id: string } | { __typename?: 'IntegrationLiability', id: string } | { __typename?: 'IntegrationPerson', id: string } | { __typename?: 'IrrevocableTrust', id: string } | { __typename?: 'JointPersonalAccount', id: string } | { __typename?: 'KGNode', id: string } | { __typename?: 'KGRelationship', id: string } | { __typename?: 'KGRoot', id: string } | { __typename?: 'KGV2Document', id: string } | { __typename?: 'KGV2DocumentChange', id: string } | { __typename?: 'KGV2DocumentModification', id: string } | { __typename?: 'KGV2Graph', id: string } | { __typename?: 'KGV2Node', id: string } | { __typename?: 'KGV2NodeAlias', id: string } | { __typename?: 'KGV2NodeEvidence', id: string } | { __typename?: 'KGV2Statement', id: string } | { __typename?: 'KGV2StatementEvidence', id: string } | { __typename?: 'KGV2StatementSupersession', id: string } | { __typename?: 'KeyPerson', id: string } | { __typename?: 'KeyPersonRole', id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'LiabilitiesBundleConfiguration', id: string } | { __typename?: 'Liability', id: string } | { __typename?: 'LiabilityPayment', id: string } | { __typename?: 'LifeInsuranceBundleConfiguration', id: string } | { __typename?: 'LifetimeExclusionEvent', id: string } | { __typename?: 'LoggedTransfer', id: string } | { __typename?: 'LuminaryOrganization', id: string } | { __typename?: 'LuminaryTenantJIT', id: string } | { __typename?: 'ManagedSFTPConnection', id: string } | { __typename?: 'Memo', id: string } | { __typename?: 'MemoPrompt', id: string } | { __typename?: 'Message', id: string } | { __typename?: 'MissingDocumentOverride', id: string } | { __typename?: 'MissingDocumentsPage', id: string } | { __typename?: 'ModelMapping', id: string } | { __typename?: 'NotificationApp', id: string } | { __typename?: 'NotificationPreference', id: string } | { __typename?: 'OpenaiSdkConfig', id: string } | { __typename?: 'OrganizationApplicationConfiguration', id: string } | { __typename?: 'OrganizationDisclaimerConfiguration', id: string } | { __typename?: 'OwnershipStake', id: string } | { __typename?: 'PlatformDocument', id: string } | { __typename?: 'PlatformFile', id: string } | { __typename?: 'PlatformFilePage', id: string } | { __typename?: 'PlatformFileParagraph', id: string } | { __typename?: 'PresentationApprovalRequest', id: string } | { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemDetail', id: string } | { __typename?: 'PresentationBundle', id: string } | { __typename?: 'PresentationBundleCoverPage', id: string } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewItem', id: string } | { __typename?: 'PresentationCoverPage', id: string } | { __typename?: 'PresentationCoverSlideConfig', id: string } | { __typename?: 'PresentationCustomPage', id: string } | { __typename?: 'PresentationCustomPageBundleConfiguration', id: string } | { __typename?: 'PresentationDiagramPage', id: string } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string } | { __typename?: 'PresentationDocumentsReviewedDocument', id: string } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveItem', id: string } | { __typename?: 'PresentationItemCitation', id: string } | { __typename?: 'PresentationPage', id: string } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string } | { __typename?: 'PresentationPlanningOpportunitiesItem', id: string } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyItem', id: string } | { __typename?: 'PresentationTemplate', id: string } | { __typename?: 'PresentationTemplateBundle', id: string } | { __typename?: 'PresentationTemplateCoverPage', id: string } | { __typename?: 'PresentationTemplateCustomPage', id: string } | { __typename?: 'PresentationTemplateDiagramPage', id: string } | { __typename?: 'PresentationTemplatePage', id: string } | { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationTrustOverviewItem', id: string } | { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string } | { __typename?: 'PresentationWillBundleConfiguration', id: string } | { __typename?: 'PresentationWillClientConfiguration', id: string } | { __typename?: 'PresentationWillItem', id: string } | { __typename?: 'Principal', id: string } | { __typename?: 'PrivateFoundation', id: string } | { __typename?: 'ProfessionalTeamRole', id: string } | (
    { __typename?: 'Proposal', id: string }
    & EstateWaterfall_ProposalFragment
  ) | { __typename?: 'ProposalScenario', id: string } | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'ReleaseGroup', id: string } | { __typename?: 'ReminderEmailNotificationRecord', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | { __typename?: 'RevocableTrust', id: string } | { __typename?: 'Role', id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string } | { __typename?: 'SSOConnection', id: string } | { __typename?: 'SalesforceExportAttempt', id: string } | { __typename?: 'ScheduledDistribution', id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } | { __typename?: 'SubBrand', id: string } | { __typename?: 'SubBrandDisclaimerConfiguration', id: string } | { __typename?: 'Submission', id: string } | { __typename?: 'TaxDragConfig', id: string } | { __typename?: 'TaxDragOverride', id: string } | { __typename?: 'Team', id: string } | { __typename?: 'Tenant', id: string } | { __typename?: 'TenantApplicationConfiguration', id: string } | { __typename?: 'TenantBranding', id: string } | { __typename?: 'TenantDisclaimerConfiguration', id: string } | { __typename?: 'TenantDocument', id: string } | { __typename?: 'TenantReminderEmailsConfiguration', id: string } | { __typename?: 'TenantSSOConnection', id: string } | { __typename?: 'TenantSecurityConfiguration', id: string } | { __typename?: 'TenantSlideConfig', id: string } | { __typename?: 'TestCMKEncryption', id: string } | { __typename?: 'TestamentaryEntity', displayName: string, gstStatus?: Types.EntityGstStatus | null, id: string, testamentaryEntityKind: Types.TestamentaryEntityKind, hypotheticalDispositionScenarios: { __typename?: 'DispositionScenarioConnection', edges?: Array<{ __typename?: 'DispositionScenarioEdge', node?: { __typename?: 'DispositionScenario', id: string } | null } | null> | null } } | { __typename?: 'TrustAdvisor', id: string } | { __typename?: 'TrustAdvisorRole', id: string } | { __typename?: 'Trustee', id: string } | { __typename?: 'TrusteeDuty', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserFeedback', id: string } | { __typename?: 'UserNotificationConfiguration', id: string } | { __typename?: 'WaterfallBundleConfiguration', id: string } | { __typename?: 'WaterfallBundleCoverPage', id: string } | { __typename?: 'WaterfallComparisonBundleConfiguration', id: string } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string } | { __typename?: 'WaterfallTemplateBundleConfiguration', id: string } | { __typename?: 'WorkOSOrganization', id: string } | { __typename?: 'WorkOSOrganizationDomain', id: string } | { __typename?: 'WorkflowTracker', id: string } }
  & EstateWaterfall_MinimalNodeFragment
);

export type EstateWaterfall_TransferLogItemFragment = (
  { __typename?: 'EstateWaterfallTransfer' }
  & EstateWaterfallTransferLogItem_EstateWaterfallTransferFragment
);

export type EstateWaterfall_EdgeFragment = { __typename?: 'EstateWaterfallVizEdge', value: CurrencyUSD, kind: Types.EstateWaterfallEdgeKind, from: (
    { __typename?: 'EstateWaterfallVizNode' }
    & EstateWaterfall_NodeFragment
  ), to: (
    { __typename?: 'EstateWaterfallVizNode' }
    & EstateWaterfall_NodeFragment
  ), associatedPouroverDispositions?: Array<{ __typename?: 'EstateWaterfallVizEdgeAssociatedDispositiveProvision', value: CurrencyUSD } | null> | null, associatedDispositiveProvisions?: Array<{ __typename?: 'EstateWaterfallVizEdgeAssociatedDispositiveProvision', value: CurrencyUSD, dispositiveProvision: (
      { __typename?: 'DispositiveProvision' }
      & DispositiveProvisions_DispositiveProvisionFragment
    ) } | null> | null, associatedTransfers?: Array<{ __typename?: 'EstateWaterfallVizEdgeAssociatedTransfer', transfer: { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string } } | null> | null, associatedLoans?: Array<{ __typename?: 'EstateWaterfallVizEdgeAssociatedLoan', loan?: { __typename?: 'EstateWaterfallLoan', id?: string | null, pseudoID?: string | null } | null }> | null, associatedTransferLogItems?: Array<(
    { __typename?: 'EstateWaterfallTransfer' }
    & EstateWaterfall_TransferLogItemFragment
  )> | null };

export type EstateWaterfall_GraphVizGroupFragment = { __typename?: 'GraphVisualizationGroup', id: string, namespace?: string | null, displayName?: string | null, description?: string | null, nodes: Array<{ __typename?: 'AISuggestion', id: string } | { __typename?: 'AISuggestionEvidence', id: string } | { __typename?: 'AccessAgeParameter', id: string } | { __typename?: 'AccessParameter', id: string } | { __typename?: 'Account', id: string } | { __typename?: 'ActiveEstateInsightsPage', id: string } | { __typename?: 'Activity', id: string } | { __typename?: 'Address', id: string } | { __typename?: 'Answer', id: string } | { __typename?: 'AnswerEvidence', id: string } | { __typename?: 'AnswerRevision', id: string } | { __typename?: 'Approval', id: string } | { __typename?: 'AssetClass', id: string } | { __typename?: 'AssetGroup', id: string } | { __typename?: 'AssetStatic', id: string } | { __typename?: 'AssetV2', id: string } | { __typename?: 'AssetValuationV2', id: string } | { __typename?: 'AssetValueV2', id: string } | { __typename?: 'AsyncJob', id: string } | { __typename?: 'BalanceSheetBundleConfiguration', id: string } | { __typename?: 'BalanceSheetCategory', id: string } | { __typename?: 'BalanceSheetViewConfiguration', id: string } | { __typename?: 'BeneficiariesBundleConfiguration', id: string } | { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string } | { __typename?: 'Beneficiary', id: string } | { __typename?: 'BeneficiaryAccessParameter', id: string } | { __typename?: 'BeneficiaryDesignationGroup', id: string } | { __typename?: 'BeneficiaryDistribution', id: string } | { __typename?: 'BeneficiaryDistributionParameter', id: string } | { __typename?: 'BeneficiaryPage', id: string } | { __typename?: 'BeneficiaryPowerOfAppointment', id: string } | { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTProposal', id: string } | { __typename?: 'CLTTrust', id: string } | { __typename?: 'CRTProposal', id: string } | { __typename?: 'CRTTrust', id: string } | { __typename?: 'Capability', id: string } | { __typename?: 'Cashflow', id: string } | { __typename?: 'ClientOrganization', id: string } | { __typename?: 'ClientPresentationV2', id: string } | { __typename?: 'ClientProfile', id: string } | { __typename?: 'ClientProfileRelationship', id: string } | { __typename?: 'Collaborator', id: string } | { __typename?: 'ComparedWaterfall', id: string } | { __typename?: 'CompletedEstateInsightsPage', id: string } | { __typename?: 'ControllingParty', id: string } | { __typename?: 'Conversation', id: string } | { __typename?: 'CoverPageConfiguration', id: string } | { __typename?: 'CustodialPersonalAccount', id: string } | { __typename?: 'DSUEPortability', id: string } | { __typename?: 'DiagramArtifact', id: string } | { __typename?: 'DiagramArtifactPrompt', id: string } | { __typename?: 'DispositionScenario', id: string } | { __typename?: 'DispositiveProvision', id: string } | { __typename?: 'DispositiveProvisionTemplate', id: string } | { __typename?: 'DividerBundleConfiguration', id: string } | { __typename?: 'DividerTemplateBundleConfiguration', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'DocumentQuestion', id: string } | { __typename?: 'DocumentQuestionAnswers', id: string } | { __typename?: 'DocumentSummary', id: string } | { __typename?: 'DocumentSummaryPage', id: string } | { __typename?: 'DocumentSummaryPrompt', id: string } | { __typename?: 'DocumentSummaryPromptTestRun', id: string } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string } | { __typename?: 'DonorAdvisedFund', id: string } | { __typename?: 'Employee', id: string } | { __typename?: 'EntitiesOverviewBundleConfiguration', id: string } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string } | { __typename?: 'Entity', id: string } | { __typename?: 'EntityDiagram', id: string } | { __typename?: 'EntityDocumentRelationship', id: string } | { __typename?: 'EntityGraphView', id: string } | { __typename?: 'EntityGraphViewBundleConfiguration', id: string } | { __typename?: 'EntityNotes', id: string } | { __typename?: 'EntityProposal', id: string } | { __typename?: 'EntitySummaryBundleConfiguration', id: string } | { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string } | { __typename?: 'EntityTask', id: string } | { __typename?: 'EntityTaxInfo', id: string } | { __typename?: 'EstateInsight', id: string } | { __typename?: 'EstateInsightReference', id: string } | { __typename?: 'EstateInsightsBundleConfiguration', id: string } | { __typename?: 'EstateTaxScenario', id: string } | { __typename?: 'EstateWaterfall', id: string } | { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string } | { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string } | { __typename?: 'EstateWaterfallMessageContext', id: string } | { __typename?: 'EstateWaterfallVisualizationConfig', id: string } | { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | { __typename?: 'FamilyTreeBundleConfiguration', id: string } | { __typename?: 'FamilyTreeConfiguration', id: string } | { __typename?: 'FeatureFlag', id: string } | { __typename?: 'FeatureFlagQueryRule', id: string } | { __typename?: 'File', id: string } | { __typename?: 'FilePage', id: string } | { __typename?: 'FileParagraph', id: string } | { __typename?: 'Form', id: string } | { __typename?: 'FormVersion', id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATAnnuityV2', id: string } | { __typename?: 'GRATProposalScenario', id: string } | { __typename?: 'GRATTrust', id: string } | { __typename?: 'GiftingProposal', id: string } | { __typename?: 'GiftingProposalCashFlow', id: string } | { __typename?: 'GiftingProposalGift', id: string } | { __typename?: 'GiftingProposalGiftSender', id: string } | { __typename?: 'GiftingProposalPortfolio', id: string } | { __typename?: 'GiftingProposalScenario', id: string } | { __typename?: 'GraphVisualizationGroup', id: string } | { __typename?: 'GrowthProfile', id: string } | { __typename?: 'GrowthProfileOverride', id: string } | { __typename?: 'Household', id: string } | { __typename?: 'HypotheticalCLT', id: string } | { __typename?: 'HypotheticalCRT', id: string } | { __typename?: 'HypotheticalGRAT', id: string } | { __typename?: 'HypotheticalInsurance', id: string } | { __typename?: 'HypotheticalSaleLoan', id: string } | { __typename?: 'HypotheticalTransferAsset', id: string } | { __typename?: 'HypotheticalTransferFundingSource', id: string } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string } | { __typename?: 'ILITCrummeyLetter', id: string } | { __typename?: 'ILITTrust', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'IncomeTaxPaymentConfig', id: string } | { __typename?: 'IndividualPersonalAccount', id: string } | { __typename?: 'InferredField', id: string } | { __typename?: 'InferredFieldEvidence', id: string } | { __typename?: 'InsightsTemplateBundleConfiguration', id: string } | { __typename?: 'InsurancePersonalAccount', id: string } | { __typename?: 'InsurancePolicy', id: string } | { __typename?: 'InsurancePremiumPayment', id: string } | { __typename?: 'IntegrationAssetClass', id: string } | { __typename?: 'IntegrationCashflow', id: string } | { __typename?: 'IntegrationClient', id: string } | { __typename?: 'IntegrationConfiguration', id: string } | { __typename?: 'IntegrationEntity', id: string } | { __typename?: 'IntegrationInsurance', id: string } | { __typename?: 'IntegrationLiability', id: string } | { __typename?: 'IntegrationPerson', id: string } | { __typename?: 'IrrevocableTrust', id: string } | { __typename?: 'JointPersonalAccount', id: string } | { __typename?: 'KGNode', id: string } | { __typename?: 'KGRelationship', id: string } | { __typename?: 'KGRoot', id: string } | { __typename?: 'KGV2Document', id: string } | { __typename?: 'KGV2DocumentChange', id: string } | { __typename?: 'KGV2DocumentModification', id: string } | { __typename?: 'KGV2Graph', id: string } | { __typename?: 'KGV2Node', id: string } | { __typename?: 'KGV2NodeAlias', id: string } | { __typename?: 'KGV2NodeEvidence', id: string } | { __typename?: 'KGV2Statement', id: string } | { __typename?: 'KGV2StatementEvidence', id: string } | { __typename?: 'KGV2StatementSupersession', id: string } | { __typename?: 'KeyPerson', id: string } | { __typename?: 'KeyPersonRole', id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'LiabilitiesBundleConfiguration', id: string } | { __typename?: 'Liability', id: string } | { __typename?: 'LiabilityPayment', id: string } | { __typename?: 'LifeInsuranceBundleConfiguration', id: string } | { __typename?: 'LifetimeExclusionEvent', id: string } | { __typename?: 'LoggedTransfer', id: string } | { __typename?: 'LuminaryOrganization', id: string } | { __typename?: 'LuminaryTenantJIT', id: string } | { __typename?: 'ManagedSFTPConnection', id: string } | { __typename?: 'Memo', id: string } | { __typename?: 'MemoPrompt', id: string } | { __typename?: 'Message', id: string } | { __typename?: 'MissingDocumentOverride', id: string } | { __typename?: 'MissingDocumentsPage', id: string } | { __typename?: 'ModelMapping', id: string } | { __typename?: 'NotificationApp', id: string } | { __typename?: 'NotificationPreference', id: string } | { __typename?: 'OpenaiSdkConfig', id: string } | { __typename?: 'OrganizationApplicationConfiguration', id: string } | { __typename?: 'OrganizationDisclaimerConfiguration', id: string } | { __typename?: 'OwnershipStake', id: string } | { __typename?: 'PlatformDocument', id: string } | { __typename?: 'PlatformFile', id: string } | { __typename?: 'PlatformFilePage', id: string } | { __typename?: 'PlatformFileParagraph', id: string } | { __typename?: 'PresentationApprovalRequest', id: string } | { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemDetail', id: string } | { __typename?: 'PresentationBundle', id: string } | { __typename?: 'PresentationBundleCoverPage', id: string } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewItem', id: string } | { __typename?: 'PresentationCoverPage', id: string } | { __typename?: 'PresentationCoverSlideConfig', id: string } | { __typename?: 'PresentationCustomPage', id: string } | { __typename?: 'PresentationCustomPageBundleConfiguration', id: string } | { __typename?: 'PresentationDiagramPage', id: string } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string } | { __typename?: 'PresentationDocumentsReviewedDocument', id: string } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveItem', id: string } | { __typename?: 'PresentationItemCitation', id: string } | { __typename?: 'PresentationPage', id: string } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string } | { __typename?: 'PresentationPlanningOpportunitiesItem', id: string } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyItem', id: string } | { __typename?: 'PresentationTemplate', id: string } | { __typename?: 'PresentationTemplateBundle', id: string } | { __typename?: 'PresentationTemplateCoverPage', id: string } | { __typename?: 'PresentationTemplateCustomPage', id: string } | { __typename?: 'PresentationTemplateDiagramPage', id: string } | { __typename?: 'PresentationTemplatePage', id: string } | { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationTrustOverviewItem', id: string } | { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string } | { __typename?: 'PresentationWillBundleConfiguration', id: string } | { __typename?: 'PresentationWillClientConfiguration', id: string } | { __typename?: 'PresentationWillItem', id: string } | { __typename?: 'Principal', id: string } | { __typename?: 'PrivateFoundation', id: string } | { __typename?: 'ProfessionalTeamRole', id: string } | { __typename?: 'Proposal', id: string } | { __typename?: 'ProposalScenario', id: string } | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'ReleaseGroup', id: string } | { __typename?: 'ReminderEmailNotificationRecord', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | { __typename?: 'RevocableTrust', id: string } | { __typename?: 'Role', id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string } | { __typename?: 'SSOConnection', id: string } | { __typename?: 'SalesforceExportAttempt', id: string } | { __typename?: 'ScheduledDistribution', id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } | { __typename?: 'SubBrand', id: string } | { __typename?: 'SubBrandDisclaimerConfiguration', id: string } | { __typename?: 'Submission', id: string } | { __typename?: 'TaxDragConfig', id: string } | { __typename?: 'TaxDragOverride', id: string } | { __typename?: 'Team', id: string } | { __typename?: 'Tenant', id: string } | { __typename?: 'TenantApplicationConfiguration', id: string } | { __typename?: 'TenantBranding', id: string } | { __typename?: 'TenantDisclaimerConfiguration', id: string } | { __typename?: 'TenantDocument', id: string } | { __typename?: 'TenantReminderEmailsConfiguration', id: string } | { __typename?: 'TenantSSOConnection', id: string } | { __typename?: 'TenantSecurityConfiguration', id: string } | { __typename?: 'TenantSlideConfig', id: string } | { __typename?: 'TestCMKEncryption', id: string } | { __typename?: 'TestamentaryEntity', id: string } | { __typename?: 'TrustAdvisor', id: string } | { __typename?: 'TrustAdvisorRole', id: string } | { __typename?: 'Trustee', id: string } | { __typename?: 'TrusteeDuty', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserFeedback', id: string } | { __typename?: 'UserNotificationConfiguration', id: string } | { __typename?: 'WaterfallBundleConfiguration', id: string } | { __typename?: 'WaterfallBundleCoverPage', id: string } | { __typename?: 'WaterfallComparisonBundleConfiguration', id: string } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string } | { __typename?: 'WaterfallTemplateBundleConfiguration', id: string } | { __typename?: 'WorkOSOrganization', id: string } | { __typename?: 'WorkOSOrganizationDomain', id: string } | { __typename?: 'WorkflowTracker', id: string }> };

export type EstateWaterfall_VizConfigFragment = { __typename?: 'EstateWaterfallVisualizationConfig', id: string, useBrandColors: boolean, hideEdges: boolean, hideEntitiesListInGroups: boolean, hideEntityValues: boolean, hideTaxTiles: boolean, hideUnfundedTiles: boolean, alwaysShowEdgeLabels: boolean };

export type EstateWaterfall_EstateWaterfallHypotheticalTransferFragment = (
  { __typename?: 'EstateWaterfallHypotheticalTransfer' }
  & HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment
);

export type EstateWaterfall_TransferLogFragment = { __typename?: 'EstateWaterfallTransfer', year: number, kind: Types.EstateWaterfallTransferKind, finalTransferAmount?: CurrencyUSD | null, source?: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string } | null, destination?: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string } | null };

export type EstateWaterfall_EstateWaterfallVizFragment = { __typename?: 'EstateWaterfallViz', _cacheKey: string, hasWaterfallData: boolean, lifetimeExemptionAppliedTowardsGiftTax?: CurrencyUSD | null, firstDeathRemainingLifetimeExemption: CurrencyUSD, secondDeathRemainingLifetimeExemption: CurrencyUSD, firstDeathInsuranceBenefit: CurrencyUSD, firstDeathInEstateInsuranceBenefit: CurrencyUSD, firstDeathOutOfEstateInsuranceBenefit: CurrencyUSD, secondDeathInsuranceBenefit?: CurrencyUSD | null, secondDeathInEstateInsuranceBenefit?: CurrencyUSD | null, secondDeathOutOfEstateInsuranceBenefit?: CurrencyUSD | null, transferLog: Array<(
    { __typename?: 'EstateWaterfallTransfer' }
    & EstateWaterfall_TransferLogFragment
  )>, eventLog: Array<(
    { __typename?: 'EstateWaterfallEvent' }
    & GetWaterfallSummary_EstateWaterfallEventFragment
  )>, beforeFirstDeathTaxSummaryV2?: (
    { __typename?: 'GiftTaxSummary' }
    & EstateWaterfall_GiftTaxSummaryFragment
  ) | null, firstDeathTaxSummaryV2: (
    { __typename?: 'TaxSummaryV2' }
    & EstateWaterfall_TaxSummaryV2Fragment
  ), secondDeathTaxSummaryV2?: (
    { __typename?: 'TaxSummaryV2' }
    & EstateWaterfall_TaxSummaryV2Fragment
  ) | null, nodes: Array<(
    { __typename?: 'EstateWaterfallVizNode' }
    & EstateWaterfall_NodeFragment
  )>, edges: Array<(
    { __typename?: 'EstateWaterfallVizEdge' }
    & EstateWaterfall_EdgeFragment
  )> };

export type EstateWaterfall_GrowthProfileFragment = (
  { __typename?: 'GrowthProfile' }
  & GetWaterfallSummary_GrowthProfileFragment
);

export type EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, skipCurrentYearGrowth: boolean, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, kind?: Types.EstateWaterfallKind | null, growthProfile?: (
    { __typename?: 'GrowthProfile' }
    & EstateWaterfall_GrowthProfileFragment
  ) | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, displayName: string }, household: { __typename?: 'Household', id: string, displayName: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, displayGivenName: string, remainingLifetimeExclusion: CurrencyUSD }> }, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string, includedClients: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string } | null } | null> | null }, includedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } | null, visualizationGroups: { __typename?: 'GraphVisualizationGroupConnection', edges?: Array<{ __typename?: 'GraphVisualizationGroupEdge', node?: (
        { __typename?: 'GraphVisualizationGroup' }
        & EstateWaterfall_GraphVizGroupFragment
      ) | null } | null> | null }, visualizationConfig?: (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateWaterfall_VizConfigFragment
  ) | null, outgoingExternalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, incomingExternalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, hypotheticalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, nodeConfigurations: Array<(
    { __typename?: 'EntityGraphNodeConfiguration' }
    & GraphViz_NodeConfigFragment
  )>, visualizationWithProjections: (
    { __typename?: 'EstateWaterfallViz' }
    & EstateWaterfall_EstateWaterfallVizFragment
  ), visualization: (
    { __typename?: 'EstateWaterfallViz' }
    & EstateWaterfall_EstateWaterfallVizFragment
  ), nonHypotheticalVisualizationWithProjections: (
    { __typename?: 'EstateWaterfallViz' }
    & EstateWaterfall_EstateWaterfallVizFragment
  ) };

export type EstateWaterfall_TaxSummaryV2Fragment = { __typename?: 'TaxSummaryV2', _cacheKey: string, taxShortfallReason?: Types.TaxShortfallReason | null, federalTax?: (
    { __typename?: 'FederalTaxDetail' }
    & TaxDetail_FederalTaxDetailFragment
  ) | null, stateTax?: Array<(
    { __typename?: 'StateTaxDetail' }
    & TaxDetail_StateTaxDetailFragment
  )> | null, stateInheritanceTax?: Array<(
    { __typename?: 'StateInheritanceTaxDetail' }
    & TaxDetail_StateInheritanceTaxDetailFragment
  )> | null, gstTax?: (
    { __typename?: 'GSTTaxDetail' }
    & TaxDetail_GstTaxDetailFragment
  ) | null };

export type EstateWaterfall_GiftTaxSummaryFragment = { __typename?: 'GiftTaxSummary', _cacheKey: string, federalGiftTax?: (
    { __typename?: 'GiftTaxDetail' }
    & TaxDetail_GiftTaxDetailFragment
  ) | null, gstGiftTax?: (
    { __typename?: 'GiftTaxDetail' }
    & TaxDetail_GiftTaxDetailFragment
  ) | null, stateGiftTax?: Array<(
    { __typename?: 'StateGiftTaxDetail' }
    & TaxDetail_StateGiftTaxDetailFragment
  )> | null };

export type EstateWaterfallQueryVariables = Types.Exact<{
  where: Types.EstateWaterfallWhereInput;
}>;


export type EstateWaterfallQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & EstateWaterfallFragment
      ) | null } | null> | null } };

export type EstateWaterfallVisualizationQueryVariables = Types.Exact<{
  where: Types.EstateWaterfallWhereInput;
  hideUnfundedTiles?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  input?: Types.InputMaybe<Types.EstateWaterfallProjectionInput>;
}>;


export type EstateWaterfallVisualizationQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string, visualizationWithProjections: (
          { __typename?: 'EstateWaterfallViz' }
          & EstateWaterfall_EstateWaterfallVizFragment
        ) } | null } | null> | null } };

export type EstateWaterfallUpdateMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type EstateWaterfallUpdateMutation = { __typename?: 'Mutation', updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export type EstateWaterfallUpdateNodesLayoutMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type EstateWaterfallUpdateNodesLayoutMutation = { __typename?: 'Mutation', updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export type EstateWaterfallBatchUpdateMutationVariables = Types.Exact<{
  input: Types.BatchUpdateEstateWaterfallInput;
}>;


export type EstateWaterfallBatchUpdateMutation = { __typename?: 'Mutation', batchUpdateEstateWaterfall: { __typename?: 'BatchUpdateEstateWaterfallPayload', createdGroupIdMapping: Array<{ __typename?: 'GroupIdMapping', tempId: string, realId: string }>, waterfall: { __typename?: 'EstateWaterfall', id: string } } };

export const Operations = {
  Query: {
    EstateWaterfall: 'EstateWaterfall' as const,
    EstateWaterfallVisualization: 'EstateWaterfallVisualization' as const
  },
  Mutation: {
    EstateWaterfallUpdate: 'EstateWaterfallUpdate' as const,
    EstateWaterfallUpdateNodesLayout: 'EstateWaterfallUpdateNodesLayout' as const,
    EstateWaterfallBatchUpdate: 'EstateWaterfallBatchUpdate' as const
  },
  Fragment: {
    EstateWaterfall_MinimalNode: 'EstateWaterfall_MinimalNode' as const,
    EstateWaterfall_InsurancePolicy: 'EstateWaterfall_InsurancePolicy' as const,
    EstateWaterfall_Proposal: 'EstateWaterfall_Proposal' as const,
    EstateWaterfall_Node: 'EstateWaterfall_Node' as const,
    EstateWaterfall_TransferLogItem: 'EstateWaterfall_TransferLogItem' as const,
    EstateWaterfall_Edge: 'EstateWaterfall_Edge' as const,
    EstateWaterfall_GraphVizGroup: 'EstateWaterfall_GraphVizGroup' as const,
    EstateWaterfall_VizConfig: 'EstateWaterfall_VizConfig' as const,
    EstateWaterfall_EstateWaterfallHypotheticalTransfer: 'EstateWaterfall_EstateWaterfallHypotheticalTransfer' as const,
    EstateWaterfall_TransferLog: 'EstateWaterfall_TransferLog' as const,
    EstateWaterfall_EstateWaterfallViz: 'EstateWaterfall_EstateWaterfallViz' as const,
    EstateWaterfall_GrowthProfile: 'EstateWaterfall_GrowthProfile' as const,
    EstateWaterfall: 'EstateWaterfall' as const,
    EstateWaterfall_TaxSummaryV2: 'EstateWaterfall_TaxSummaryV2' as const,
    EstateWaterfall_GiftTaxSummary: 'EstateWaterfall_GiftTaxSummary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfall_GrowthProfileFragmentDoc = gql`
    fragment EstateWaterfall_GrowthProfile on GrowthProfile {
  ...GetWaterfallSummary_GrowthProfile
}
    ${GetWaterfallSummary_GrowthProfileFragmentDoc}`;
export const EstateWaterfall_GraphVizGroupFragmentDoc = gql`
    fragment EstateWaterfall_GraphVizGroup on GraphVisualizationGroup {
  id
  namespace
  displayName
  description
  nodes {
    id
  }
}
    `;
export const EstateWaterfall_VizConfigFragmentDoc = gql`
    fragment EstateWaterfall_VizConfig on EstateWaterfallVisualizationConfig {
  id
  useBrandColors
  hideEdges
  hideEntitiesListInGroups
  hideEntityValues
  hideTaxTiles
  hideUnfundedTiles
  alwaysShowEdgeLabels
}
    `;
export const EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc = gql`
    fragment EstateWaterfall_EstateWaterfallHypotheticalTransfer on EstateWaterfallHypotheticalTransfer {
  ...HypotheticalTransferUtils_EstateWaterfallHypotheticalTransfer
}
    ${HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragmentDoc}`;
export const EstateWaterfall_TransferLogFragmentDoc = gql`
    fragment EstateWaterfall_TransferLog on EstateWaterfallTransfer {
  year
  kind
  finalTransferAmount
  source {
    _cacheKey
    id
  }
  destination {
    _cacheKey
    id
  }
}
    `;
export const EstateWaterfall_GiftTaxSummaryFragmentDoc = gql`
    fragment EstateWaterfall_GiftTaxSummary on GiftTaxSummary {
  _cacheKey
  federalGiftTax {
    ...TaxDetail_GiftTaxDetail
  }
  gstGiftTax {
    ...TaxDetail_GiftTaxDetail
  }
  stateGiftTax {
    ...TaxDetail_StateGiftTaxDetail
  }
}
    ${TaxDetail_GiftTaxDetailFragmentDoc}
${TaxDetail_StateGiftTaxDetailFragmentDoc}`;
export const EstateWaterfall_TaxSummaryV2FragmentDoc = gql`
    fragment EstateWaterfall_TaxSummaryV2 on TaxSummaryV2 {
  _cacheKey
  federalTax {
    ...TaxDetail_FederalTaxDetail
  }
  stateTax {
    ...TaxDetail_StateTaxDetail
  }
  stateInheritanceTax {
    ...TaxDetail_StateInheritanceTaxDetail
  }
  gstTax {
    ...TaxDetail_GSTTaxDetail
  }
  taxShortfallReason
}
    ${TaxDetail_FederalTaxDetailFragmentDoc}
${TaxDetail_StateTaxDetailFragmentDoc}
${TaxDetail_StateInheritanceTaxDetailFragmentDoc}
${TaxDetail_GstTaxDetailFragmentDoc}`;
export const EstateWaterfall_MinimalNodeFragmentDoc = gql`
    fragment EstateWaterfall_MinimalNode on EstateWaterfallVizNode {
  id
  _cacheKey
  isHidden
  afterDeath
  value
  waterfallID
  group {
    id
    namespace
  }
  isHypothetical
}
    `;
export const EstateWaterfall_InsurancePolicyFragmentDoc = gql`
    fragment EstateWaterfall_InsurancePolicy on InsurancePolicy {
  ...EstateWaterfallInsurancePolicy_InsurancePolicy
}
    ${EstateWaterfallInsurancePolicy_InsurancePolicyFragmentDoc}`;
export const EstateWaterfall_ProposalFragmentDoc = gql`
    fragment EstateWaterfall_Proposal on Proposal {
  id
  displayName
  cltProposal {
    id
  }
  crtProposal {
    id
  }
  household {
    id
  }
}
    `;
export const EstateWaterfall_NodeFragmentDoc = gql`
    fragment EstateWaterfall_Node on EstateWaterfallVizNode {
  ...EstateWaterfall_MinimalNode
  transferredToEstateTax
  transferredToGiftingTax
  waterfallID
  valueBeforeDispositions
  valueHistory {
    year
    beginningOfYearValue
  }
  valueBeforePouroverWills
  inEstateStatus
  addedDeathBenefit
  futureDeathBenefit
  valueBeforeDispositions
  valueBeforePouroverWills
  taxableValue
  nonTaxableValue
  nodeConfiguration {
    ...GraphViz_NodeConfig
  }
  node {
    id
    ... on Entity {
      entityKind: kind
      extendedDisplayKind
      stage
      subtype {
        id
        displayName
        dispositionScenarios {
          id
        }
        ... on ILITTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on InsurancePersonalAccount {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on IrrevocableTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on RevocableTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on GRATTrust {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on SLATTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on QPRTTrust {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on CLTTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on CRTTrust {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on IndividualPersonalAccount {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on JointPersonalAccount {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on RetirementPersonalAccount {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on CustodialPersonalAccount {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on QualifiedTuitionPersonalAccount {
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on DonorAdvisedFund {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on PrivateFoundation {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
          hypotheticalDispositionScenarios {
            edges {
              node {
                id
              }
            }
          }
        }
        ... on CCorpBusinessEntity {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
        }
        ... on SCorpBusinessEntity {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
        }
        ... on LLCBusinessEntity {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
        }
        ... on LPBusinessEntity {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
        }
        ... on GPBusinessEntity {
          policies {
            ...EstateWaterfall_InsurancePolicy
          }
        }
      }
    }
    ... on TestamentaryEntity {
      testamentaryEntityKind: kind
      displayName
      gstStatus
      hypotheticalDispositionScenarios {
        edges {
          node {
            id
          }
        }
      }
    }
    ... on ClientProfile {
      displayName
      lastName
      hypotheticalDispositionScenarios {
        edges {
          node {
            id
          }
        }
      }
    }
    ... on ClientOrganization {
      name
      clientOrganizationKind: kind
    }
    ... on Proposal {
      ...EstateWaterfall_Proposal
    }
  }
}
    ${EstateWaterfall_MinimalNodeFragmentDoc}
${GraphViz_NodeConfigFragmentDoc}
${EstateWaterfall_InsurancePolicyFragmentDoc}
${EstateWaterfall_ProposalFragmentDoc}`;
export const EstateWaterfall_TransferLogItemFragmentDoc = gql`
    fragment EstateWaterfall_TransferLogItem on EstateWaterfallTransfer {
  ...EstateWaterfallTransferLogItem_EstateWaterfallTransfer
}
    ${EstateWaterfallTransferLogItem_EstateWaterfallTransferFragmentDoc}`;
export const EstateWaterfall_EdgeFragmentDoc = gql`
    fragment EstateWaterfall_Edge on EstateWaterfallVizEdge {
  from {
    ...EstateWaterfall_Node
  }
  to {
    ...EstateWaterfall_Node
  }
  value
  kind
  associatedPouroverDispositions {
    value
  }
  associatedDispositiveProvisions {
    value
    dispositiveProvision {
      ...DispositiveProvisions_DispositiveProvision
    }
  }
  associatedTransfers {
    transfer {
      id
    }
  }
  associatedLoans {
    loan {
      id
      pseudoID
    }
  }
  associatedTransferLogItems {
    ...EstateWaterfall_TransferLogItem
  }
}
    ${EstateWaterfall_NodeFragmentDoc}
${DispositiveProvisions_DispositiveProvisionFragmentDoc}
${EstateWaterfall_TransferLogItemFragmentDoc}`;
export const EstateWaterfall_EstateWaterfallVizFragmentDoc = gql`
    fragment EstateWaterfall_EstateWaterfallViz on EstateWaterfallViz {
  _cacheKey
  hasWaterfallData
  lifetimeExemptionAppliedTowardsGiftTax
  firstDeathRemainingLifetimeExemption
  secondDeathRemainingLifetimeExemption
  firstDeathInsuranceBenefit
  firstDeathInEstateInsuranceBenefit
  firstDeathOutOfEstateInsuranceBenefit
  secondDeathInsuranceBenefit
  secondDeathInEstateInsuranceBenefit
  secondDeathOutOfEstateInsuranceBenefit
  transferLog {
    ...EstateWaterfall_TransferLog
  }
  eventLog {
    ...GetWaterfallSummary_EstateWaterfallEvent
  }
  beforeFirstDeathTaxSummaryV2 {
    ...EstateWaterfall_GiftTaxSummary
  }
  firstDeathTaxSummaryV2 {
    ...EstateWaterfall_TaxSummaryV2
  }
  secondDeathTaxSummaryV2 {
    ...EstateWaterfall_TaxSummaryV2
  }
  nodes {
    ...EstateWaterfall_Node
  }
  edges {
    ...EstateWaterfall_Edge
  }
}
    ${EstateWaterfall_TransferLogFragmentDoc}
${GetWaterfallSummary_EstateWaterfallEventFragmentDoc}
${EstateWaterfall_GiftTaxSummaryFragmentDoc}
${EstateWaterfall_TaxSummaryV2FragmentDoc}
${EstateWaterfall_NodeFragmentDoc}
${EstateWaterfall_EdgeFragmentDoc}`;
export const EstateWaterfallFragmentDoc = gql`
    fragment EstateWaterfall on EstateWaterfall {
  id
  displayName
  skipCurrentYearGrowth
  growthProfile {
    ...EstateWaterfall_GrowthProfile
  }
  firstGrantorDeath {
    id
    displayName
  }
  household {
    id
    displayName
    possiblePrimaryClients {
      id
      displayName
      displayGivenName
      remainingLifetimeExclusion
    }
  }
  filter {
    id
    includedClients {
      edges {
        node {
          id
        }
      }
    }
    includedEntities {
      edges {
        node {
          id
        }
      }
    }
  }
  firstGrantorDeathYear
  secondGrantorDeathYear
  visualizationGroups {
    edges {
      node {
        ...EstateWaterfall_GraphVizGroup
      }
    }
  }
  visualizationConfig {
    ...EstateWaterfall_VizConfig
  }
  outgoingExternalTransfers: hypotheticalTransfers(
    where: {destinationKind: EXTERNAL}
  ) {
    edges {
      node {
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  incomingExternalTransfers: hypotheticalTransfers(where: {sourceKind: EXTERNAL}) {
    edges {
      node {
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  hypotheticalTransfers {
    edges {
      node {
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  nodeConfigurations {
    ...GraphViz_NodeConfig
  }
  visualizationWithProjections {
    ...EstateWaterfall_EstateWaterfallViz
  }
  visualization {
    ...EstateWaterfall_EstateWaterfallViz
  }
  nonHypotheticalVisualizationWithProjections: visualizationWithProjections(
    opts: {runWaterfallAsNonHypothetical: true}
  ) {
    ...EstateWaterfall_EstateWaterfallViz
  }
  kind
}
    ${EstateWaterfall_GrowthProfileFragmentDoc}
${EstateWaterfall_GraphVizGroupFragmentDoc}
${EstateWaterfall_VizConfigFragmentDoc}
${EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc}
${GraphViz_NodeConfigFragmentDoc}
${EstateWaterfall_EstateWaterfallVizFragmentDoc}`;
export const EstateWaterfallDocument = gql`
    query EstateWaterfall($where: EstateWaterfallWhereInput!) {
  estateWaterfalls(where: $where) {
    edges {
      node {
        ...EstateWaterfall
      }
    }
  }
}
    ${EstateWaterfallFragmentDoc}`;

/**
 * __useEstateWaterfallQuery__
 *
 * To run a query within a React component, call `useEstateWaterfallQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateWaterfallQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEstateWaterfallQuery(baseOptions: Apollo.QueryHookOptions<EstateWaterfallQuery, EstateWaterfallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateWaterfallQuery, EstateWaterfallQueryVariables>(EstateWaterfallDocument, withFetchPolicyContext(options));
      }
export function useEstateWaterfallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateWaterfallQuery, EstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateWaterfallQuery, EstateWaterfallQueryVariables>(EstateWaterfallDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateWaterfallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateWaterfallQuery, EstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateWaterfallQuery, EstateWaterfallQueryVariables>(EstateWaterfallDocument, withFetchPolicyContext(options));
        }
export type EstateWaterfallQueryHookResult = ReturnType<typeof useEstateWaterfallQuery>;
export type EstateWaterfallLazyQueryHookResult = ReturnType<typeof useEstateWaterfallLazyQuery>;
export type EstateWaterfallSuspenseQueryHookResult = ReturnType<typeof useEstateWaterfallSuspenseQuery>;
export type EstateWaterfallQueryResult = Apollo.QueryResult<EstateWaterfallQuery, EstateWaterfallQueryVariables>;
export const EstateWaterfallVisualizationDocument = gql`
    query EstateWaterfallVisualization($where: EstateWaterfallWhereInput!, $hideUnfundedTiles: Boolean, $input: EstateWaterfallProjectionInput) {
  estateWaterfalls(where: $where) {
    edges {
      node {
        id
        visualizationWithProjections(
          input: $input
          opts: {hideUnfundedTiles: $hideUnfundedTiles}
        ) {
          ...EstateWaterfall_EstateWaterfallViz
        }
      }
    }
  }
}
    ${EstateWaterfall_EstateWaterfallVizFragmentDoc}`;

/**
 * __useEstateWaterfallVisualizationQuery__
 *
 * To run a query within a React component, call `useEstateWaterfallVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateWaterfallVisualizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      hideUnfundedTiles: // value for 'hideUnfundedTiles'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstateWaterfallVisualizationQuery(baseOptions: Apollo.QueryHookOptions<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>(EstateWaterfallVisualizationDocument, withFetchPolicyContext(options));
      }
export function useEstateWaterfallVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>(EstateWaterfallVisualizationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateWaterfallVisualizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>(EstateWaterfallVisualizationDocument, withFetchPolicyContext(options));
        }
export type EstateWaterfallVisualizationQueryHookResult = ReturnType<typeof useEstateWaterfallVisualizationQuery>;
export type EstateWaterfallVisualizationLazyQueryHookResult = ReturnType<typeof useEstateWaterfallVisualizationLazyQuery>;
export type EstateWaterfallVisualizationSuspenseQueryHookResult = ReturnType<typeof useEstateWaterfallVisualizationSuspenseQuery>;
export type EstateWaterfallVisualizationQueryResult = Apollo.QueryResult<EstateWaterfallVisualizationQuery, EstateWaterfallVisualizationQueryVariables>;
export const EstateWaterfallUpdateDocument = gql`
    mutation EstateWaterfallUpdate($input: AugmentedUpdateEstateWaterfallInput!) {
  updateEstateWaterfall(input: $input) {
    id
  }
}
    `;
export type EstateWaterfallUpdateMutationFn = Apollo.MutationFunction<EstateWaterfallUpdateMutation, EstateWaterfallUpdateMutationVariables>;

/**
 * __useEstateWaterfallUpdateMutation__
 *
 * To run a mutation, you first call `useEstateWaterfallUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estateWaterfallUpdateMutation, { data, loading, error }] = useEstateWaterfallUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstateWaterfallUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EstateWaterfallUpdateMutation, EstateWaterfallUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EstateWaterfallUpdateMutation, EstateWaterfallUpdateMutationVariables>(EstateWaterfallUpdateDocument, options);
      }
export type EstateWaterfallUpdateMutationHookResult = ReturnType<typeof useEstateWaterfallUpdateMutation>;
export type EstateWaterfallUpdateMutationResult = Apollo.MutationResult<EstateWaterfallUpdateMutation>;
export type EstateWaterfallUpdateMutationOptions = Apollo.BaseMutationOptions<EstateWaterfallUpdateMutation, EstateWaterfallUpdateMutationVariables>;
export const EstateWaterfallUpdateNodesLayoutDocument = gql`
    mutation EstateWaterfallUpdateNodesLayout($input: AugmentedUpdateEstateWaterfallInput!) {
  updateEstateWaterfall(input: $input) {
    id
  }
}
    `;
export type EstateWaterfallUpdateNodesLayoutMutationFn = Apollo.MutationFunction<EstateWaterfallUpdateNodesLayoutMutation, EstateWaterfallUpdateNodesLayoutMutationVariables>;

/**
 * __useEstateWaterfallUpdateNodesLayoutMutation__
 *
 * To run a mutation, you first call `useEstateWaterfallUpdateNodesLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallUpdateNodesLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estateWaterfallUpdateNodesLayoutMutation, { data, loading, error }] = useEstateWaterfallUpdateNodesLayoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstateWaterfallUpdateNodesLayoutMutation(baseOptions?: Apollo.MutationHookOptions<EstateWaterfallUpdateNodesLayoutMutation, EstateWaterfallUpdateNodesLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EstateWaterfallUpdateNodesLayoutMutation, EstateWaterfallUpdateNodesLayoutMutationVariables>(EstateWaterfallUpdateNodesLayoutDocument, options);
      }
export type EstateWaterfallUpdateNodesLayoutMutationHookResult = ReturnType<typeof useEstateWaterfallUpdateNodesLayoutMutation>;
export type EstateWaterfallUpdateNodesLayoutMutationResult = Apollo.MutationResult<EstateWaterfallUpdateNodesLayoutMutation>;
export type EstateWaterfallUpdateNodesLayoutMutationOptions = Apollo.BaseMutationOptions<EstateWaterfallUpdateNodesLayoutMutation, EstateWaterfallUpdateNodesLayoutMutationVariables>;
export const EstateWaterfallBatchUpdateDocument = gql`
    mutation EstateWaterfallBatchUpdate($input: BatchUpdateEstateWaterfallInput!) {
  batchUpdateEstateWaterfall(input: $input) {
    createdGroupIdMapping {
      tempId
      realId
    }
    waterfall {
      id
    }
  }
}
    `;
export type EstateWaterfallBatchUpdateMutationFn = Apollo.MutationFunction<EstateWaterfallBatchUpdateMutation, EstateWaterfallBatchUpdateMutationVariables>;

/**
 * __useEstateWaterfallBatchUpdateMutation__
 *
 * To run a mutation, you first call `useEstateWaterfallBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estateWaterfallBatchUpdateMutation, { data, loading, error }] = useEstateWaterfallBatchUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstateWaterfallBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EstateWaterfallBatchUpdateMutation, EstateWaterfallBatchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EstateWaterfallBatchUpdateMutation, EstateWaterfallBatchUpdateMutationVariables>(EstateWaterfallBatchUpdateDocument, options);
      }
export type EstateWaterfallBatchUpdateMutationHookResult = ReturnType<typeof useEstateWaterfallBatchUpdateMutation>;
export type EstateWaterfallBatchUpdateMutationResult = Apollo.MutationResult<EstateWaterfallBatchUpdateMutation>;
export type EstateWaterfallBatchUpdateMutationOptions = Apollo.BaseMutationOptions<EstateWaterfallBatchUpdateMutation, EstateWaterfallBatchUpdateMutationVariables>;